var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"card bg-primary"},[_c('a',{staticClass:"btn btn-success waves-effect waves-light",attrs:{"href":"/customer/add"}},[_vm._v("Add a new customer")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }